import AdminVariantAdd from "./add";

export default AdminVariantAdd;
